import { CatalogData } from "../../data/catalogData";
import { DeclarationPropertyValueData } from "../../data/declarationPropertyValueData";
import { OperationData } from "../../data/operationData";
import { OperationRequestData } from "../../data/operationRequestData";
import { Dictionary } from "../../data/types";
import currencyFilter from "../../filters/currency.filter";

/**
 * Детальная информация по операции 
 */
export class OperationDetailsModel {
  /**Краткая информация по операции */
  public OperationData: OperationData = new OperationData(null);
  /**Подробная информация по операции (из запроса) */
  public RequestData: OperationRequestData | null = null;
  /**Информация по категории операции */
  public RespondentData: CatalogData | null = null;
  /**Детали операции */
  public Details: DeclarationPropertyValueData[] = [];

  constructor(
    operationData: OperationData,
    requestData: OperationRequestData | null = null,
    respondentData: CatalogData | null = null,
    details: DeclarationPropertyValueData[] = []
  ) {
    this.OperationData = operationData;
    this.RequestData = requestData;
    this.RespondentData = respondentData;
    this.Details = this.isDboOperation ? requestData.details : details;
    if (requestData.details.length > 0) {
      this.Details.forEach((detail: DeclarationPropertyValueData) => {
        if (detail && detail.Value.includes(this.OperationData.Currency))
          detail.Value = detail.Value.replace(this.OperationData.Currency, currencyFilter(this.OperationData.Currency))
      })
    }
  }

  private get isDboOperation(): boolean {
    if (!this.OperationData.ReferenceId)
      return false;
    if (this.RequestData.operationId > 0 || this.RequestData.details.length > 0)
      return true;
    return false;
  }
}
